module.exports = ".modal-xl-lg {\n  max-width: 80%;\n  min-width: 800px; }\n\n.subtitle {\n  font-size: 0.85em; }\n\n@media print {\n  .modal {\n    position: absolute;\n    left: 0;\n    top: 0;\n    margin: 0;\n    padding: 0;\n    overflow: visible !important; }\n  .modal-xl-lg {\n    max-width: 98%; }\n  .table tr {\n    page-break-inside: avoid; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/movimientos-obra/movimientos-modal/movimientos-modal.component.scss
// module id = ./src/app/components/movimientos-obra/movimientos-modal/movimientos-modal.component.scss
// module chunks = main